// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3q_mO","loaderOuter":"PageOverlayLoader_loaderOuter__3Axgh"};